// extracted by mini-css-extract-plugin
module.exports = {"pillButton":"src-components-UI-Buttons-PillButton-styles-style-module__pillButton--2p5FU"};